export const sv = {
  justNow: 'Just nu',
  minutesAgo: '{n} min sedan',
  hoursAgo: '{n} tim sedan',
  dayAgo: '{n} dag sedan',
  daysAgo: '{n} dagar sedan',
  welcomeBack: 'Välkommen tillbaka, {name}',
  pendingBookings: 'Väntande bokningar',
  totalBookings: 'Bokningar totalt',
  upcomingBookings: 'Kommande bokningar',
  averageRating: 'Snittbetyg',
  newRequests: 'Nya förfrågningar',
  activeQuotes: 'Aktiva offerter',
  conversionRate: 'Konverteringsgrad',
  revenueTitle: 'Omsättning (6 månader)',
  revenueDescCarCare: 'Slutförda bokningar per månad (bokat datum)',
  revenueDescGarage: 'Slutförda och betalda bokningar per månad (bokat datum)',
  loading: 'Laddar…',
  noDataYet: 'Ingen data ännu',
  newBookingsThisWeek: 'Nya bokningar denna vecka',
  quotesThisWeek: 'Offerter denna vecka',
  bookingsPerDayDesc: 'Antal skapade bokningar per dag (vecka startar måndag)',
  quotesPerDayDesc: 'Antal skickade offerter per dag (vecka startar måndag)',
  recentActivity: 'Senaste aktivitet',
  recentBookingUpdates: 'Senaste bokningsuppdateringar',
  requestsQuotesBookings: 'Förfrågningar, offerter och bokningar',
  noActivityYet: 'Ingen aktivitet att visa ännu.',
  onboarding: {
    title: 'Kom igång',
    progress: '{done} av {total} klart',
    subtitle: 'Fyll i det här så att kunderna hittar och väljer er.',
    optional: 'Valfritt',
    dismiss: 'Dölj',
    description: 'Skriv en kort beskrivning',
    branding: 'Ladda upp logotyp',
    hours: 'Ange öppettider',
    location: 'Kontrollera adress och kartposition',
    phone: 'Lägg till telefonnummer',
    services: 'Lägg till tjänster med priser',
    staff: 'Bjud in en kollega',
    first_quote: 'Skicka er första offert',
    first_booking: 'Ta emot er första bokning',
  },
}

export const en: typeof sv = {
  justNow: 'Just now',
  minutesAgo: '{n} min ago',
  hoursAgo: '{n} h ago',
  dayAgo: '{n} day ago',
  daysAgo: '{n} days ago',
  welcomeBack: 'Welcome back, {name}',
  pendingBookings: 'Pending bookings',
  totalBookings: 'Total bookings',
  upcomingBookings: 'Upcoming bookings',
  averageRating: 'Average rating',
  newRequests: 'New requests',
  activeQuotes: 'Active quotes',
  conversionRate: 'Conversion rate',
  revenueTitle: 'Revenue (6 months)',
  revenueDescCarCare: 'Completed bookings per month (booking date)',
  revenueDescGarage: 'Completed and paid bookings per month (booking date)',
  loading: 'Loading…',
  noDataYet: 'No data yet',
  newBookingsThisWeek: 'New bookings this week',
  quotesThisWeek: 'Quotes this week',
  bookingsPerDayDesc: 'Number of bookings created per day (week starts Monday)',
  quotesPerDayDesc: 'Number of quotes sent per day (week starts Monday)',
  recentActivity: 'Recent activity',
  recentBookingUpdates: 'Latest booking updates',
  requestsQuotesBookings: 'Requests, quotes and bookings',
  noActivityYet: 'No activity to show yet.',
  onboarding: {
    title: 'Get started',
    progress: '{done} of {total} done',
    subtitle: 'Fill these in so customers can find and choose you.',
    optional: 'Optional',
    dismiss: 'Hide',
    description: 'Write a short description',
    branding: 'Upload your logo',
    hours: 'Set opening hours',
    location: 'Check address and map position',
    phone: 'Add a phone number',
    services: 'Add services with prices',
    staff: 'Invite a colleague',
    first_quote: 'Send your first quote',
    first_booking: 'Get your first booking',
  },
}
